export default __webpack_public_path__ + "assets/1b03f5a239e3231dc1797b6bc29054f1/06.jpg";